"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[5715],{

/***/ 3365:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6466);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6361);
/* harmony import */ var _core_shopify_init_section_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8711);



const NAMESPACE = '.js-social-showcase-section';
(0,_core_shopify_init_section_index_js__WEBPACK_IMPORTED_MODULE_2__.initSection)('.js-social-showcase-section', (_section)=>{
    const section = jquery__WEBPACK_IMPORTED_MODULE_0___default()(_section);
    const slideshowContainer = section.find('.js-swiper').first();
    const slideCount = parseInt(slideshowContainer.attr('data-item-count') || '0', 10);
    const slideshowContainerElement = slideshowContainer.get(0);
    if (!slideshowContainerElement || slideCount < 1) {
        return {
            unload: null
        };
    }
    const swiper = new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](slideshowContainerElement, {
        modules: [
            swiper__WEBPACK_IMPORTED_MODULE_1__.Navigation,
            swiper__WEBPACK_IMPORTED_MODULE_1__.Scrollbar
        ],
        direction: 'horizontal',
        slidesPerView: 1.25,
        spaceBetween: 20,
        loop: false,
        slidesOffsetAfter: 16,
        scrollbar: {
            el: '.js-social-showcase-swiper-scrollbar',
            draggable: true
        },
        breakpoints: {
            1024: {
                slidesPerView: 2.5,
                spaceBetween: 32,
                slidesOffsetAfter: 0
            }
        },
        init: false
    });
    section.on('click' + NAMESPACE, '.js-swiper-arrow', function(evt) {
        evt.preventDefault();
        const action = jquery__WEBPACK_IMPORTED_MODULE_0___default()(evt.currentTarget).attr('data-action');
        const swiperAction = action === 'prev' ? 'slidePrev' : 'slideNext';
        swiper[swiperAction]();
    });
    swiper.init();
    section.on('click' + NAMESPACE, '.js-video', function(evt) {
        var _$_find;
        evt.preventDefault();
        const target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(evt.currentTarget);
        const videoID = target.attr('data-video');
        const videoElem = (_$_find = jquery__WEBPACK_IMPORTED_MODULE_0___default()(NAMESPACE).find(`.js-video[data-video=${videoID}] video`)) === null || _$_find === void 0 ? void 0 : _$_find.get(0);
        const videoPlayElem = jquery__WEBPACK_IMPORTED_MODULE_0___default()(NAMESPACE).find(`.js-video[data-video=${videoID}] .js-video-play`);
        if (videoElem instanceof HTMLVideoElement) {
            if (videoElem.paused) {
                videoPlayElem.css('display', 'none');
                videoElem.play();
                videoElem.controls = true;
            } else {
                videoPlayElem.css('display', 'block');
                videoElem.pause();
                videoElem.controls = false;
            }
        }
    });
    return {
        unload: ()=>{
            section.off(NAMESPACE);
            swiper.destroy();
        },
        selectBlock: (block)=>{
            var _block_closest;
            if (swiper.autoplay) {
                swiper.autoplay.stop();
            }
            const slideIndex = parseInt(((_block_closest = block.closest('.swiper-slide')) === null || _block_closest === void 0 ? void 0 : _block_closest.getAttribute('data-swiper-slide-index')) || '0', 10);
            if (Number.isNaN(slideIndex) === false) {
                swiper.slideTo(slideIndex);
            }
            return ()=>{
                if (swiper.autoplay) {
                    swiper.autoplay.start();
                }
            };
        }
    };
});


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(3365)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);